<template>
  <span class="ellipsis"></span>
</template>

<style scoped lang="scss">
@keyframes ellipsis-anim {
  0% {
    content: '';
  }
  33% {
    content: '.';
  }
  66% {
    content: '..';
  }
  100% {
    content: '...';
  }
}

.ellipsis {
  display: inline-block;
  width: 0.75em;
  text-align: left;
  vertical-align: bottom;
}

.ellipsis::after {
  content: '.';
  animation: ellipsis-anim 1.5s infinite;
}
</style>
